export const CLASSROOM_NAME_MAX_LENGTH = 100;
export const CLASSROOM_MEMBER_DISPLAY_NAME_MAX_LENGTH = 14;

export const validateClassroomName = (name: string) => {
  const trimmed = name.trim();
  return trimmed.length > 0 && trimmed.length <= CLASSROOM_NAME_MAX_LENGTH;
};

export const validateMemberDisplayName = (name: string) => {
  const trimmed = name.trim();
  return (
    trimmed.length > 0 &&
    trimmed.length <= CLASSROOM_MEMBER_DISPLAY_NAME_MAX_LENGTH
  );
};
